// extracted by mini-css-extract-plugin
export default {"main":"Navbar_main__CtG8S"};